import { InAppBrowser, InAppBrowserEvent } from '@awesome-cordova-plugins/in-app-browser';
import { Capacitor } from '@capacitor/core';

interface OpenBrowerOptions {
  target?: string;
  onMessage?: (event: MessageEvent | InAppBrowserEvent) => void;
  onExit?: () => void;
}

export const openBrowser = (url: string, {
  target,
  onMessage,
  onExit,
}: OpenBrowerOptions = {}) => {
  if (Capacitor.isNativePlatform()) {
    const isIos = Capacitor.getPlatform() === 'ios';

    const inApp = InAppBrowser.create(
      url,
      target ?? '_blank',
      {
        toolbartranslucent: 'no',
        toolbarposition: 'top',
        lefttoright: isIos ? 'yes' : 'no',
        hidenavigationbuttons: 'yes',
        hideurlbar: 'yes',
        toolbarcolor: '#FFEBEB',
        closebuttoncolor: '#FF3333',
        closebuttoncaption: 'Cerrar',
      },
    );

    if (onMessage) {
      inApp.on('message').subscribe((event) => {
        onMessage(event.data);
        inApp.close();
      });
    }

    if (onExit) {
      inApp.on('exit').subscribe(onExit);
    }

    return inApp;
  }

  const openedTab = window.open(url, '_blank');
  const originUrl = new URL(url).origin;

  const handleListener = (event: MessageEvent) => {
    if (onMessage) {
      if (event.origin === originUrl) {
        onMessage(event);
        if (openedTab) openedTab.close();
        window.removeEventListener('message', handleListener);
      }
    }
  };

  if (onMessage) {
    window.addEventListener('message', handleListener);
  }

  if (onExit || onMessage) {
    const timer = setInterval(() => {
      if (openedTab?.closed) {
        clearInterval(timer);
        if (onExit) onExit();
        if (onMessage) window.removeEventListener('message', handleListener);
      }
    }, 500);
  }

  return openedTab;
};
